export default "__VITE_ASSET__CGAQSC5N__"